import { MailError } from "@styled-icons/fluentui-system-regular/MailError";
import { newColors } from "constants/newColors";
import styled from "styled-components";

export const StyledMailDetailCard = styled.div`
  display: flex;
  flex-direction: column;
  background: ${newColors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  height: 100%;
  padding: 1.5rem 2rem;
`;

export const StyledMailHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 1rem;
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: solid 1px ${newColors.border};
  margin-bottom: 1.5rem;
`;

export const StyledMailToContainer = styled.div`
  display: flex;
`;

export const StyledMailHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  align-items: left;
  column-gap: 1rem;
  row-gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const StyledMailContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const StyledMailMessage = styled.div`
  white-space: pre-wrap;
`;

export const StyledMailError = styled(MailError)`
  width: 1rem;
  margin-right: 0.25rem;
  color: ${newColors.red};
`;
